import moment from '@/plugins/moment.js';

export default {
    appointments: [],
    automations: [],
    currentImport: {},
    imports: [],
    matchedColumns: [],
    previewRows: [],
    selectedAppointments: [],
    selectedAutomation: {},
    selectedAutomations: [],
    selectedDate: moment().format('YYYY-MM-DD'),
};
